import { DEVICE_NAME } from './vice-constants';

export const itemsInArrayCount = (inputArray = []) => {
  if (!inputArray.length) return {};
  const inputCounts = {};
  for (const num of inputArray) {
    inputCounts[num] = inputCounts[num] ? inputCounts[num] + 1 : 1;
  }
  return inputCounts;
};

export const generateCameraData = (
  name,
  cameraDeviceId = 'default',
  isActive = false,
  camLabel = null,
) => ({
  name,
  camLabel,
  uniqueId: name.toLowerCase().replace(/ /g, '_'),
  cameraDeviceId,
  micDeviceId: 'default',
  localTracks: [],
  deviceSelection: {
    [DEVICE_NAME.MICROPHONE]: { active: false, choice: null },
    [DEVICE_NAME.SPEAKERS]: { active: false, choice: null },
    [DEVICE_NAME.CAMERA]: { active: false, choice: null },
  },
  jitsiRoom: null,
  audioRef: null,
  videoRef: null,
  image: `https://ui-avatars.com/api/?name=${name}&bold=true&background=FFFFFF&color=24b8a6&format=PNG`,
  isMicrophoneOn: false,
  isCameraOn: false,
  isActive,
});

export const getBrowserNameAndVersion = () => {
  const ua = navigator.userAgent;
  let tem;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return `IE ${tem[1] || ''}`;
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

  tem = ua.match(/version\/(\d+)/i);
  if (tem != null) {
    M.splice(1, 1, tem[1]);
  }

  return M.join(' ');
};

export const getOSInfo = () => {
  const userAgent = window.navigator.userAgent;
  let osName = 'Unknown OS';
  let osVersion = 'Unknown Version';

  if (userAgent.indexOf('Win') !== -1) {
    osName = 'Windows';
    if (userAgent.indexOf('Windows NT 10.0') !== -1) osVersion = '10';
    else if (userAgent.indexOf('Windows NT 6.3') !== -1) osVersion = '8.1';
    else if (userAgent.indexOf('Windows NT 6.2') !== -1) osVersion = '8';
    else if (userAgent.indexOf('Windows NT 6.1') !== -1) osVersion = '7';
    else if (userAgent.indexOf('Windows NT 6.0') !== -1) osVersion = 'Vista';
    else if (userAgent.indexOf('Windows NT 5.1') !== -1) osVersion = 'XP';
    else if (userAgent.indexOf('Windows NT 5.0') !== -1) osVersion = '2000';
  } else if (userAgent.indexOf('Mac') !== -1) {
    osName = 'Mac OS X';

    // macOS versions in chronological order (oldest to newest)
    if (userAgent.indexOf('Mac OS X 10_7') !== -1) osVersion = 'Lion';
    else if (userAgent.indexOf('Mac OS X 10_16') !== -1 || userAgent.indexOf('Mac OS X 11') !== -1)
      osVersion = 'Big Sur';
    else if (userAgent.indexOf('Mac OS X 10_15') !== -1) osVersion = 'Catalina';
    else if (userAgent.indexOf('Mac OS X 10_14') !== -1) osVersion = 'Mojave';
    else if (userAgent.indexOf('Mac OS X 10_13') !== -1) osVersion = 'High Sierra';
    else if (userAgent.indexOf('Mac OS X 10_12') !== -1) osVersion = 'Sierra';
    else if (userAgent.indexOf('Mac OS X 10_11') !== -1) osVersion = 'El Capitan';
    else if (userAgent.indexOf('Mac OS X 10_10') !== -1) osVersion = 'Yosemite';
    else if (userAgent.indexOf('Mac OS X 10_9') !== -1) osVersion = 'Mavericks';
    else if (userAgent.indexOf('Mac OS X 12') !== -1) osVersion = 'Monterey';
    else if (userAgent.indexOf('Mac OS X 13') !== -1) osVersion = 'Ventura';
    else if (userAgent.indexOf('Mac OS X 14') !== -1) osVersion = 'Sonoma';
    else if (userAgent.indexOf('Mac OS X 15') !== -1) osVersion = 'Sequoia';

    // Modern user agent strings may use different patterns
  } else if (userAgent.indexOf('Linux') !== -1) {
    osName = 'Linux';
  } else if (userAgent.indexOf('X11') !== -1) {
    osName = 'UNIX';
  } else if (userAgent.indexOf('Android') !== -1) {
    osName = 'Android';
    // Add more Android versions as needed
  } else if (userAgent.indexOf('like Mac') !== -1) {
    osName = 'iOS';
    // Add more iOS versions as needed
  }

  return `${osName} ${osVersion}`;
};

export const getScreenResolution = () => {
  const width = Math.trunc(window.screen.width * window.devicePixelRatio);
  const height = Math.trunc(window.screen.height * window.devicePixelRatio);

  return `${width}x${height}`;
};
export const capitalizeFirstLetter = (str) =>
  String(str).charAt(0).toUpperCase() + String(str).slice(1);
